import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"document-location"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M21.75 16.75C21.75 20.0035 18 22.5 18 22.5C18 22.5 14.25 20.0035 14.25 16.75C14.25 14.6789 15.9289 13 18 13C20.0711 13 21.75 14.6789 21.75 16.75Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M17.75 17H18.25M21.75 16.75C21.75 20.0035 18 22.5 18 22.5C18 22.5 14.25 20.0035 14.25 16.75C14.25 14.6789 15.9289 13 18 13C20.0711 13 21.75 14.6789 21.75 16.75Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M20.5 9.5V2.5L3.5 2.5V21.5H12M8 8H16M8 12H11","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const DocumentLocation = Vue.extend<IconProps>({
  name: 'DocumentLocationIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'document-location',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default DocumentLocation;
